import { Goal, ID } from '@griply/types';

// Resolves a goal's life area, walking up the parent chain when the goal has no direct lifeAreaId.
export const getGoalLifeArea = (
  goal: Goal,
  goals: Goal[],
  visited: Set<ID> = new Set(),
): ID | undefined => {
  const parentIds = goal.parentIds ?? [];
  if (goal.lifeAreaId || !parentIds.length) {
    return goal.lifeAreaId ?? undefined;
  }

  if (visited.has(goal.id)) {
    return undefined;
  }
  visited.add(goal.id);

  // The last parentIds entry is the direct parent — the nearest explicit lifeAreaId wins.
  const parentGoal = goals.find(
    (g) => g.id === parentIds[parentIds.length - 1],
  );
  return parentGoal ? getGoalLifeArea(parentGoal, goals, visited) : undefined;
};
